/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "admin/layouts/dashboard";

import Users from "admin/layouts/users";
import TelegramSubscribers from "admin/layouts/telegram-subscribers";
import Events from "admin/layouts/events";
import AdminReports from "admin/layouts/reports";
import IntelPointsPage from "admin/layouts/intel-points";
import AdminArsenal from "admin/layouts/arsenal";
import TrafficObserver from "admin/layouts/traffic";
import DataCollection from "admin/layouts/data-collection";
import DataSources from "admin/layouts/data-sources";
import AutomatedRoutines from "admin/layouts/automated-routines";
import SatelliteAnalysis from "admin/layouts/satellite-analysis";
import MapBuilderPage from "admin/layouts/map-builder";
import EmailReports from "admin/layouts/email-reports";
import RTL from "admin/layouts/rtl";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },


  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "Telegram Subscribers",
    key: "telegram-subscribers",
    icon: <Icon fontSize="small">send</Icon>,
    route: "/telegram-subscribers",
    component: <TelegramSubscribers />,
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">crisis_alert</Icon>,
    route: "/events",
    component: <Events />,
  },
  {
    type: "collapse",
    name: "Intel Points",
    key: "intel-points",
    icon: <Icon fontSize="small">tips_and_updates</Icon>,
    route: "/intel-points",
    component: <IntelPointsPage />,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/reports",
    component: <AdminReports />,
  },
  {
    type: "collapse",
    name: "Satellite Analysis",
    key: "satellite-analysis",
    icon: <Icon fontSize="small">satellite_alt</Icon>,
    route: "/satellite-analysis",
    component: <SatelliteAnalysis />,
  },
  {
    type: "collapse",
    name: "Map Builder",
    key: "map-builder",
    icon: <Icon fontSize="small">edit_location_alt</Icon>,
    route: "/map-builder",
    component: <MapBuilderPage />,
  },
  {
    type: "collapse",
    name: "Email Reports",
    key: "email-reports",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/email-reports",
    component: <EmailReports />,
  },
  {
    type: "collapse",
    name: "Map",
    key: "map",
    icon: <Icon fontSize="small">map</Icon>,
    href: "/map",
  },
  {
    type: "collapse",
    name: "Arsenal",
    key: "arsenal",
    icon: <Icon fontSize="small">security</Icon>,
    route: "/arsenal",
    component: <AdminArsenal />,
  },
  {
    type: "collapse",
    name: "Traffic Observer",
    key: "traffic",
    icon: <Icon fontSize="small">monitoring</Icon>,
    route: "/traffic",
    component: <TrafficObserver />,
  },
  {
    type: "collapse",
    name: "Data Collection",
    key: "data-collection",
    icon: <Icon fontSize="small">radar</Icon>,
    route: "/data-collection",
    component: <DataCollection />,
  },
  {
    type: "collapse",
    name: "Automated Routines",
    key: "automated-routines",
    icon: <Icon fontSize="small">engineering</Icon>,
    route: "/automated-routines",
    component: <AutomatedRoutines />,
  },
  {
    type: "collapse",
    name: "Data Sources",
    key: "data-sources",
    icon: <Icon fontSize="small">rss_feed</Icon>,
    route: "/data-sources",
    component: <DataSources />,
  },
  {
    type: "collapse",
    name: "Daily Reports",
    key: "daily-reports",
    icon: <Icon fontSize="small">summarize</Icon>,
    href: "/daily-reports",
  },

];

export default routes;
